import { render, staticRenderFns } from "./progress.vue?vue&type=template&id=624e130e&"
import script from "./progress.vue?vue&type=script&lang=js&"
export * from "./progress.vue?vue&type=script&lang=js&"
import style0 from "./progress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports